import React, { useEffect } from 'react';
import { Table } from 'reactstrap';
import { useSelector } from 'react-redux';
import { selectBookingDate, selectCartItems, selectCartTotals, selectIsEdit, setTotal } from 'slices/booking/cartSlice';
import { useDispatch } from 'react-redux';
import { calculateBookingTotals } from './calculateBookingTotals';
import { selectAccessibilityOptions, selectSelectedPostcode } from 'slices/booking/bookingSlice';
import convertDateFormat from 'Components/Date/DateFormat';

function OrderSummarySection() {

  const dispatch = useDispatch();
  const items = useSelector(selectCartItems);
  const date = useSelector(selectBookingDate);
  const { cleaningDeposit, vat, subTotal, discountAmount, depositCollected, depositAmount } = useSelector(selectCartTotals);
  const isEdit = useSelector(selectIsEdit);

  const accessibility_options = useSelector(selectAccessibilityOptions);
  const deliveryCharges = useSelector(selectSelectedPostcode)?.charges;
  
  const { additionalCharges, vatAmount, totalWithVAT, subTotal: productTotal,} = 
  calculateBookingTotals(
    {
      subTotal: subTotal, 
      cleaningDeposit: cleaningDeposit, 
      vat: vat, 
    }, 
    accessibility_options, 
    Number(deliveryCharges) || 0, 
    discountAmount || 0
  );

  useEffect(() => {
    dispatch(setTotal({total: totalWithVAT}))
  } ,[totalWithVAT, dispatch]);

  return (
    <div>
      <Table className="mb-0">
        <tbody>

          <tr>
            <td className="border-0 ps-0 fw-bold">Booking Date</td>
            <td className="border-0 text-end pe-0 fw-bold">{convertDateFormat(date || '')}</td>
          </tr>

          {items.map((item) => (
            <tr key={item.id}>
              <td className="border-0 ps-0">{item.name + ' x ' + Number(item.amount)}</td>
              <td className="border-0 text-end pe-0">£{(Number(item.price) * Number(item.amount))}</td>
            </tr>
          ))}
         
          {cleaningDeposit > 0 && (
            <tr>
              <td className="border-0 ps-0">Cleaning Deposit</td>
              <td className="border-0 text-end pe-0">£{cleaningDeposit.toFixed(2)}</td>
            </tr>
          )}
          {deliveryCharges > 0 && (
            <tr>
              <td className="border-0 ps-0" style={{ whiteSpace: 'nowrap' }}>Delivery Charges</td>
              <td className="border-0 text-end pe-0">£{deliveryCharges.toFixed(2)}</td>
            </tr>
          )}
          <tr>
            <td className="border-0 ps-0">Additional Charges</td>
            <td className="border-0 text-end pe-0">£{additionalCharges.toFixed(2)}</td>
          </tr>
          
          {discountAmount > 0 && (
            <tr>
              <td className="border-0 ps-0">Discount</td>
              <td className="border-0 text-end pe-0">{`-£${Number(discountAmount).toFixed(2)}`}</td>
            </tr>
          )}

          <tr>
            <td className="border-0 ps-0 fw-bold">Subtotal</td>
            <td className="border-0 text-end pe-0">£{productTotal.toFixed(2)}</td>
          </tr>

          <tr>
            <td className="border-0 ps-0">VAT ({vat}%)</td>
            <td className="border-0 text-end pe-0">£{vatAmount.toFixed(2)}</td>
          </tr>
          
          <tr>
            <th className="border-0 ps-0">Total</th>
            <th className="border-0 text-end pe-0">£{totalWithVAT.toFixed(2)}</th>
          </tr>

          {
            isEdit && depositCollected && depositAmount > 0 && (
              <>
              <tr>
                <td className="border-0 ps-0">Deposit</td>
                <td className="border-0 text-end pe-0">£{depositAmount.toFixed(2)}</td>
              </tr>
              <tr>
                <td className="border-0 ps-0">Remaining Deposit</td>
                <td className="border-0 text-end pe-0">£{(totalWithVAT - depositAmount).toFixed(2)}</td>
              </tr>
              </>
            )}
        </tbody>
      </Table>
    </div>
  );
}

export default OrderSummarySection;
